<router-outlet></router-outlet>
<ngx-ui-loader bgsColor="#132649" bgsPosition="bottom-right" bgsType="ball-spin-clockwise" blur=5 delay=0
    fastFadeOut=true fgsColor="#132649" fgsPosition="center-center" fgsType="ball-spin-clockwise"
    logoPosition="center-center" logoUrl="" masterLoaderId="master" overlayBorderRadius="0"
    overlayColor="rgba(40, 40, 40, 0.8)" pbColor="#132649" pbDirection="ltr"
    textPosition="center-center"></ngx-ui-loader>